import {
  Avatar,
  Button,
  DialogContent,
  Link,
  Stack,
  Typography,
} from '@mui/material';
import { DisabilityConfirmationItem } from './DisabilityApprovalItem';
import { useDictionary, useIsDesktop } from 'Hooks';
import { useEffect, useState } from 'react';
import { PaginationResult2 } from 'Components';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import {
  IDisabilityConfirmation,
  IEligibleFamilyMember,
  getEligibleFamilyMembers,
} from 'API/disabilityConfirmation';
import { MedIssueReport } from './MedIssueReport';
import { CustomDialog } from 'Components/CustomDialog';
import { Download2, LeftArrow, PurpleAlert } from 'Images';
import { FamilyMembersDialog } from './FamilyMembersDialog';
import { useSearchParams } from 'react-router-dom';

interface IDisabilityConfirmationList {
  disabilityConfirmations: IDisabilityConfirmation[];
  isHasMedHistory: boolean;
}

const paginationLimit = 10;
const familyMembersConfirmationsAttachmentId = 9;

export const DisabilityConfirmationsList = ({
  disabilityConfirmations,
  isHasMedHistory,
}: IDisabilityConfirmationList) => {
  const [pagination, setPagination] = useState<boolean>(false);
  const [showDialog, setShowDialog] = useState<boolean>(false);

  const isDesktop = useIsDesktop();

  const familyMembersConfirmation = disabilityConfirmations.find(
    (confirmation) =>
      confirmation.attachmentId === familyMembersConfirmationsAttachmentId
  );

  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (!searchParams.get('isFamilyConfirmation')) return;

    if (
      disabilityConfirmations
        ?.slice(0, pagination ? undefined : paginationLimit)
        .filter((confirmation) => !confirmation.isEnglish)
        .findIndex(
          (confirmation) =>
            confirmation.attachmentId === familyMembersConfirmationsAttachmentId
        ) !== -1
    )
      setShowDialog(true);
  }, []);

  return (
    <>
      <Stack gap={isDesktop ? '24px' : '20px'} maxWidth='850px' mt='48px'>
        {disabilityConfirmations
          ?.slice(0, pagination ? undefined : paginationLimit)
          .filter((confirmation) => !confirmation.isEnglish)
          .map((confirmation: IDisabilityConfirmation, index: number) => (
            <DisabilityConfirmationItem
              key={index}
              disabilityConfirmation={confirmation}
              onClick={
                confirmation.attachmentId ===
                familyMembersConfirmationsAttachmentId
                  ? () => {
                      setShowDialog(true);
                    }
                  : undefined
              }
            />
          ))}
        {isHasMedHistory && <MedIssueReport />}
        {disabilityConfirmations.length >= 10 && !pagination && (
          <PaginationResult2
            text={Dictionary[DICTIONARY.DisabilityApprovals].moreApprovals}
            onClick={() => setPagination(true)}
          />
        )}
      </Stack>
      {familyMembersConfirmation && (
        <FamilyMembersDialog
          confirmation={familyMembersConfirmation}
          showDialog={showDialog}
          setShowDialog={setShowDialog}
        />
      )}
    </>
  );
};
